import React, { useState, useContext } from "react";

export type DefaultContext = {
  isFiltersDialogOpen: boolean;
  setIsFiltersDialogOpen: (isOpen: boolean) => void;
};

const RootElementContext = React.createContext<DefaultContext>(
  {} as DefaultContext,
);
const useRootElement = () => useContext(RootElementContext);

const RootElementContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isFiltersDialogOpen, setIsFiltersDialogOpen] = useState(false);

  return (
    <RootElementContext.Provider
      value={{
        isFiltersDialogOpen,
        setIsFiltersDialogOpen,
      }}
    >
      {children}
    </RootElementContext.Provider>
  );
};

export { useRootElement, RootElementContextProvider };
